import React, { useRef } from "react";

import "../css/AttachmentMenu.css"; // Ensure this CSS file is created too
import DocumentIcon from "static/images/DocumentIcon";
import PhotosIcon from "static/images/PhotosIcon";
import { t } from "components/CentralDataMangement/translation/Translation";
import type { AttachmentMenuProps } from "../annotations/WhatsAppAnnotations";

const attachmentOptions = [
  { icon: <DocumentIcon />, label: t("Document"), formats: '.pdf,.doc,.docx,.txt, .xls, .xlsx' },
  { icon: <PhotosIcon />, label: t("Photos"), formats: '.jpg,.jpeg,.png' },
];

const AttachmentMenu: React.FC<AttachmentMenuProps> = ({
  show,
  handleFileUpload,
}) => {
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleClick = (acceptTypes: string) => {
    if (fileInputRef.current) {
      fileInputRef.current.accept = acceptTypes;
      fileInputRef.current.click();
    }
  };

  if (!show) {return null;}
  return (
    <div className="attachment-menu position-absolute marginBottomPoint5  shadow paddingPoint5">
      {attachmentOptions.map(({ icon, label, formats }, idx) => (
        <div
          key={idx}
          className="d-flex align-items-center documentList"
          onClick={() => handleClick(formats)}
        >
          <div className="documentIcon">{icon}</div>
          <div>{label}</div>
        </div>
      ))}
      <input
        type="file"
        ref={fileInputRef}
        style={{ display: "none" }}
        onChange={(e) => handleFileUpload(e)}
        multiple
      />
    </div>
  );
};

export default AttachmentMenu;
